module.exports = __webpack_public_path__ + "img/1492951435.22fd760f.jpg";